import React, {useState} from 'react';
import {NavLink} from 'react-router-dom';
import { LogoWhite, CloseIcon, MenuWhiteIcon } from 'components/vectors';
import { HashLink as Link } from 'react-router-hash-link';


const CommonHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  
    const linksConfig = [
      {
        path: '#about',
        title: 'About us',
        isBox: false,
        isHash: true
      },
      {
        path: '#licensing',
        title: 'Licensing',
        isBox: false,
        isHash: true
      },
      {
        path: '#service',
        title: 'Services',
        isBox: false,
        isHash: true
      },
      {
        path: '#contact',
        title: 'Contact Us',
        isBox: false,
        isHash: true
      }
    ];

    const linksConfig2 = [
        {
            path: '/login',
            title: 'Login',
            isBox: false
        },
        {
            path: '',
            title: 'Try it for Free',
            isBox: true
        }
    ];

    const LinkComponent = ({ path, title, isBox, isHash }) => (
      <li className={`menu-list-item home ${isBox ? 'box box--white' : ''}`}>
        {isHash ? (
          <Link to={path}>{title}</Link>
        ) : (
          <NavLink to={path}>{title}</NavLink>
        )}
      </li>
    );

    const createHeaderLinks = (linkConfig, NavComponent) => linkConfig.map( (link, index) => <NavComponent key={index}  {...link} />)
    return (
      <div className="row header home">
        <NavLink to="/">
          <LogoWhite />
        </NavLink>

        <ul className="d-none d-md-flex menu-list mx-auto">
          {createHeaderLinks(linksConfig, LinkComponent)}
        </ul>

        <ul className="d-none d-md-flex  menu-list  ml-auto">
          {createHeaderLinks(linksConfig2, LinkComponent)}
        </ul>
        <div className="header-hamburger" onClick={() => setIsOpen(true)}>
          <MenuWhiteIcon />
        </div>
        {isOpen ? (
          <div className="header-side-menu">
            <div onClick={() => setIsOpen(false)}>
              <CloseIcon />
            </div>

            <ul className="list-item">
              <li className="list-items">
                <Link to="#about">About Us</Link>
              </li>
              <li className="list-items">
                <Link to="#licensing">Licensing</Link>
              </li>
              <li className="list-items">
                <Link to="#services">Services</Link>
              </li>
              <li className="list-items">
                <Link to="#contact">Contact Us</Link>
              </li>
              <li className="list-items">
                <NavLink to="/login">Login</NavLink>
              </li>
            </ul>
          </div>
        ) : null}
      </div>
    );
}

export default CommonHeader;